<template>
  <div class="baniere pt-4 pb-20">
    <div
      class="w-full pt-4"
      data-aos="fade-right"
      data-aos-duration="2000"
    >
      <div class="titre w-full mt-5">
        Un système évolutif
      </div>
    </div>

    <div
      class="title1 mt-5 pr-0"
      data-aos="fade-right"
      data-aos-duration="2000"
    >
      Lors du développement de nos solutions, nous croyons à la fonctionnalité croisée. Cette attitude garantit
      la facilité du flux de travail et du recyclage des données entre les modules. Nous préservons la flexibilité
      et l'adoption rapide des différents besoins des entreprises. Nous donnons aux administrateurs de
      l'entreprise/du système la possibilité de créer et de modifier les flux de travail et le schéma de
      données, de concevoir des écrans et des modèles, ce qui permet de réaliser d'importantes économies
      et d'introduire plus rapidement des produits sur le marché. En utilisant le système de gestion des
      prêts numériques de 41DEVS, le coût total de possession et de maintenance peut être réduit par rapport
      aux offres d'autres fournisseurs.
    </div>

    <div class="text-center mt-10">
      <img
        src="../../../assets/images/jpg/system.jpg"
        alt=""
        class="md:w-4/5 w-full"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .titre{
    font-weight: 800;
    font-size: 40px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: $black;
  }
  .title1{
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
    color: $black;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .titre{
      font-size: 28px;
    }
    .title1{
      font-size: 18px;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 30px;
    }
    .title3{
      font-size: 22px;
    }
    .titre1{
      font-size: 20px;
    }

    .blocc {
      padding: 30px;
    }
  }

</style>
